import _regeneratorRuntime from "D:\\new-code\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Coupon from "../Coupon.vue";
export default {
  name: "ClassesDetailInfo",
  components: {
    Coupon: Coupon
  },
  props: {
    detail: {
      type: Object,
      default: function _default() {}
    },
    couponList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      nowDate: Date.now() / 1000
    };
  },
  computed: {
    isSoldOut: function isSoldOut() {
      return this.detail.compilation_num <= this.detail.sales_num;
    }
  },
  methods: {
    onGetCoupon: function onGetCoupon(id) {
      this.$emit("getCoupon", id);
    },
    onBuy: function () {
      var _onBuy = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var obj;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.detail.buy_online_switch == 2)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (!this.isSoldOut) {
                  _context.next = 5;
                  break;
                }

                this.$alert("你来晚了哦,名额已经没有了", "提示");
                return _context.abrupt("return");

              case 5:
                obj = {
                  shop_id: this.detail.id,
                  shop_type: 19,
                  coupon_id: 0,
                  product_number: 1
                };
                this.$router.push({
                  name: "OrderConfirm",
                  params: {
                    id: this.detail.id
                  },
                  query: {
                    type: 19,
                    order_type: 1,
                    shop_infos: JSON.stringify([obj])
                  }
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onBuy() {
        return _onBuy.apply(this, arguments);
      }

      return onBuy;
    }(),
    goToStudy: function goToStudy() {
      this.$router.push({
        name: "MemberClassesDetail",
        params: {
          id: this.detail.min_class_id
        } //小班id

      });
    }
  }
};